import {
  RiArrowDownSLine,
  RiArrowRightSLine,
  RiArrowUpSLine,
} from "react-icons/ri";
import TableModeOfRequirement from "./TableModeOfRequirement";
import { useEffect, useState } from "react";

export default function ModeOfRequirement({ setData, initialState }) {
  const initialRecruitments = initialState?.project_job_enquiry_recruitment;
  const [modeOfRecruitments, setModeOfRecruitments] = useState(
    initialRecruitments || []
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      mode_of_recruitment_edit: modeOfRecruitments
        ?.filter((data) => data?.type != "new")
        ?.map((data) => ({
          mode_of_recruitment_id: data?.id,
          name: data?.name,
          description: data?.description,
        })),
      mode_of_recruitment_new: modeOfRecruitments
        ?.filter((data) => data?.type == "new")
        ?.map((data) => ({
          name: data?.name,
          description: data?.description,
        })),
    }));
  }, [modeOfRecruitments]);

  return (
    <div className="flex flex-wrap  gap-4 ">
      <div className="max-w-sm min-w-max  w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Mode of recruitment</h2>
          <p>Provide Mode of recruitment.</p>
        </div>
      </div>
      <div
        className={`w-full m-2  px-4 rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <button
          type="button"
          onClick={() => {
            const newRow = {
              description: "",
              name: "",
              id: Math.floor(Math.random() * 10000),
              type: "new",
            };

            setModeOfRecruitments((prev) => [...prev, newRow]);
          }}
          className="bg-red text-white p-2 rounded-md mt-2 ml-2"
        >
          + Add Another
        </button>
        <TableModeOfRequirement
          setData={setData}
          modeOfRecruitments={modeOfRecruitments}
          setModeOfRecruitments={setModeOfRecruitments}
        />
      </div>
    </div>
  );
}
